export const ru = {
    error: 'Произошла ошибка',
    'no-group-found': 'Группы не найдены',
    'search-by-group': 'Поиск по группам',
    'select-campaign-for-group': 'Выберите кампанию в столбце слева'
};
